import { requests } from '../helper/Agent';

export default class ScoreAPI {
  static getScoreList() {
    return requests.get('/scores');
  }
}
